module.exports = __webpack_public_path__ + "static/media/profile.5594875a.jpg";